import { Box, Group, useMantineTheme } from '@mantine/core';

import { IconDownload } from '~/domains/design-system/icons/IconDownload';

import { useStyles } from './TableExportButtons.styles';

type TableExportButtonsProps = {
  /** Whether to show "Export all pages" (for paginated tables) */
  showExportAll?: boolean;
  /** When true, omits top border (e.g. when directly below pagination footer) */
  noTopBorder?: boolean;
  /** Inline variant: 12px text, no container - for use in footer row */
  variant?: 'default' | 'inline';
};

export function TableExportButtons({
  showExportAll = true,
  noTopBorder = false,
  variant = 'default',
}: TableExportButtonsProps) {
  const { classes, cx } = useStyles();
  const theme = useMantineTheme();
  const iconColor = theme.colors.gray2[7];

  const exportButton = (
    <button
      type="button"
      className={classes.exportButton}
      onClick={() => {
        // TODO: Export current page to CSV
      }}
    >
      <IconDownload size={12} color={iconColor} />
      <span>Export page (.csv)</span>
    </button>
  );

  const exportAllButton = showExportAll && (
    <button
      type="button"
      className={classes.exportButton}
      onClick={() => {
        // TODO: Export all pages to CSV
      }}
    >
      <IconDownload size={12} color={iconColor} />
      <span>Export all pages (.csv)</span>
    </button>
  );

  if (variant === 'inline') {
    return (
      <Group className={classes.inlineGroup} spacing={theme.other.spacing._24}>
        {exportButton}
        {exportAllButton}
      </Group>
    );
  }

  return (
    <Box className={cx(classes.container, noTopBorder && classes.noTopBorder)}>
      <Group className={classes.buttons} spacing="sm">
        {exportButton}
        {exportAllButton}
      </Group>
    </Box>
  );
}
